import {useAccidentCoveragePopulator} from '../populator/useAccidentCoveragePopulator';
import {useDispatch} from 'react-redux';

export const useAccidentCoverageDispatcher = () => {
    const populateAccidentCoverage = useAccidentCoveragePopulator();
    const dispatch = useDispatch();

    const dispatchCoverage = (selectedRate) => {
        const data = populateAccidentCoverage(selectedRate);
        dispatch({
            type: 'UPDATE_MEMBER_ELECTION',
            data: data
        });
    };

    return (selectedRate) => dispatchCoverage(selectedRate);
};